import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import Authenticated from '../shared/Authenticated';
import EnableIntegration from '../shared/EnableIntegration';
import { ServerErrorSVG, CoverageSVG } from '../img/GlobalSVG';
import Button from '../components/common/button';

import AddUsers from '../api/AddUser';
import AddUserEmployerType from '../api/AddUserEmployerType';
import AddUserInsurerType from '../api/AddUserInsurerType';
import BLOBList from '../api/BLOBList';
import EmployerList from '../api/EmployerList';
import LocationList from '../api/LocationList';
import GetAdminConfiguration from '../api/GetAdminConfig';
import RegistrationInfo from '../api/RegistrationInfo';
import UserList from '../api/UserList';
import UserListDetails from '../api/UserListDetails';
import MemberCoverageSummary from '../api/MemberCoverageSummary';
import MemberSummary from '../api/MemberSummary';
import Dependent from '../api/Dependent';
import ClaimStatusSummary from '../api/ClaimStatusSummary';
import ClaimsList from '../api/ClaimsList';
import RetryAPI from '../api/RetryAPI';
import APIEndpoints from '../api/APIEndpoints';
import SpendingAccountSummary from '../api/SpendingAccountSummary';
import MyProfileDetails from '../api/myProfileDetails';
import CookiesService from '../shared/CookiesService';
import AdminUserDetails from '../api/AdminUserDetails';
import Breadcrumbs from '../api/Breadcrumbs';
import MasterPermissions from '../api/MasterPermissions';
import GenericButton from '../../Components/GenericButton/GenericButton';
import { useSelector } from 'react-redux';

const OTPError = () => {
  const [backtoLogin, setBackToLogin] = useState(false);

  const handleBacktoLogin = () => {
    setBackToLogin(true);
  };

  const supportEmail = useSelector(
    (state) => state?.user?.emailAdminConfigData?.Login_Support_Email,
  );

  useEffect(() => {
    if (EnableIntegration.isAPIIntegrationEnabled())
      CookiesService.remove('loginToken', { path: '/' });
    Authenticated.logout(() => {
      AddUsers.resetAddUers();
      AddUserEmployerType.resetAddUersInsurer();
      AddUserInsurerType.resetAddUersInsurer();
      BLOBList.resetBLOBList();
      EmployerList.resetEmployerList();
      GetAdminConfiguration.resetAdminConfigurationResp();
      LocationList.resetLocationList();
      RegistrationInfo.resetRegistrationInfo();
      UserList.resetUserList();
      UserListDetails.resetUserListDetails();
      MemberSummary.resetMemberSummary();
      MemberCoverageSummary.resetMemberCoverageSummary();
      Dependent.resetDependent();
      ClaimStatusSummary.resetClaimStatusSummary();
      RetryAPI.resetRetryAPI();
      ClaimsList.resetClaimsList();
      SpendingAccountSummary.resetSpendingSummary();
      MyProfileDetails.resetMyProfileDetails();
      CookiesService.clear();
      APIEndpoints.resetDomainResources();
      AdminUserDetails.resetUserListDetails();
      Breadcrumbs.resetUserListDetails();
      MasterPermissions.resetPermissionFramework();
    });
  }, []);

  if (backtoLogin) {
    return <Navigate to="/admin" push={true}></Navigate>;
  }

  return (
    <>
      <Container className="otp-attempt-failed-container text-center">
        <Row>
          <Col>
            <ServerErrorSVG.OTPErrorSVG />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="content-box">
              <h1 className="password-success-title">
                Your account has been locked due to <br />
                too many invalid login attempts
              </h1>
              <p>
                You have exceeded the maximum OTP attempts and your account has
                been locked! Contact Login Requests at{' '}
                {supportEmail && supportEmail?.length
                  ? supportEmail
                  : 'Health Plan Adminstrator'}
              </p>
              <GenericButton
                variant="primary"
                tabIndex="0"
                onClick={handleBacktoLogin}
                className=" login-button d-flex mx-auto text-center "
                type="submit"
              >
                LOGIN AGAIN
              </GenericButton>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="did-you-know-container-box d-flex">
              <CoverageSVG.BulbSVG />
              <div className="content-box text-left">
                <h4>Did you know?</h4>
                <p>
                  If you are physically tired, the best thing to do is exercise
                  as it will give you more energy than sitting.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OTPError;
